// The old AngularJS version used $sce.trustAsHtml. React uses dangerouslySetInnerHTML.
// This sanitizer keeps common formatting/link tags and removes scripts/events.
const ALLOWED_TAGS = new Set(['A', 'BR', 'B', 'STRONG', 'I', 'EM', 'U', 'P', 'SPAN', 'DIV']);
const ALLOWED_ATTRIBUTES = new Set(['href', 'target', 'rel', 'title']);

export function sanitizeHtml(input) {
  if (!input) {
    return '';
  }

  const template = document.createElement('template');
  template.innerHTML = String(input);

  cleanNode(template.content);

  return template.innerHTML;
}

function cleanNode(node) {
  [...node.childNodes].forEach((child) => {
    if (child.nodeType === Node.ELEMENT_NODE) {
      if (!ALLOWED_TAGS.has(child.tagName)) {
        child.replaceWith(document.createTextNode(child.textContent ?? ''));
        return;
      }

      [...child.attributes].forEach((attribute) => {
        const attrName = attribute.name.toLowerCase();
        const attrValue = attribute.value || '';

        if (!ALLOWED_ATTRIBUTES.has(attrName) || attrName.startsWith('on')) {
          child.removeAttribute(attribute.name);
          return;
        }

        if (attrName === 'href' && /^javascript:/i.test(attrValue.trim())) {
          child.removeAttribute(attribute.name);
        }
      });

      if (child.tagName === 'A') {
        child.setAttribute('target', '_blank');
        child.setAttribute('rel', 'noopener noreferrer');
      }
    }

    cleanNode(child);
  });
}
